<template>
  <div class="deal-carousel-card">
    <base-image
      v-if="card.image?.src"
      :desktop-url="card.image.src"
      :desktop-alt="card.image.alt"
      :custom-params="{ desktop: 500, tablet: 400, mobile: 715, mobileS: 430 }"
      class="deal-carousel-card__image"
    />
    <div class="deal-carousel-card__content">
      <h3 v-if="card.title" class="deal-carousel-card__title font-s">{{ card.title }}</h3>
      <p
        v-if="card.shortDescription"
        :key="card.shortDescription"
        v-truncate-text="{
          dynamicText: card.shortDescription,
          maxLength: 108,
          showMoreText: t('introduction-show-more'),
          showLessText: t('introduction-show-less'),
          buttonClass: 'link',
        }"
        class="deal-carousel-card__description"
      >
        {{ card.shortDescription }}
      </p>
      <button class="deal-carousel-card__link link" type="button" @click="onDealClick()">
        {{ t('iorder-view-deal') }}
      </button>
    </div>
  </div>
  <deal-modal v-if="modalVisible" :card="card" @close-modal="onCloseModal" />
</template>

<script setup lang="ts">
import type { DealCarouselCardProps } from '../types';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import vTruncateText from '../../../../directives/vTruncateText';
import BaseImage from '../../../2_elements/BaseImage/BaseImage.vue';
import DealModal from '../DealModal/DealModal.vue';

const { t } = useI18n();
defineProps<DealCarouselCardProps>();

const modalVisible = ref(false);

const onDealClick = () => {
  modalVisible.value = true;
};

const onCloseModal = () => {
  modalVisible.value = false;
};
</script>

<style lang="scss">
@import './scss/DealCarouselCard.scss';
</style>
